import { Action } from 'redux';
import { RemoveAlert } from './AppActionTypes';
import { isActionFactory } from './isActionFactory';

export interface RemoveAlertAction extends Action {
  alertId: string;
}

export function removeAlertAction(alertId: string): RemoveAlertAction {
  return {
    type: RemoveAlert,
    alertId: alertId
  };
}

export const isRemoveAlertAction = isActionFactory<RemoveAlertAction>(RemoveAlert);
